export const locale = {
	lang: 'fr',
	data: {
		menu_pwa: 'PWAs',

		my_companies_header_navbar: 'Mes entreprises',
		companies_search: 'Tapez pour rechercher',

		language_header_navbar: 'Langues',
		theme_mode_header_navbar: 'Mode du thème',
		account_manage_header_navbar: 'Gérer le compte',
		sign_out_header_navbar: 'Se déconnecter',
		light_mode_header_navbar: 'Clair',
		dark_mode_header_navbar: 'Sombre',
		system_mode_header_navbar: 'Système',
		add_company_header_navbar: 'Entreprise',

		en_EN: 'Anglais',
		fr_FR: 'Français',
		es_ES: 'Espagnol',
		pt_PT: 'Portugais',

		drawer_back: 'Retour',
		drawer_create: 'Créer',
		drawer_update: 'Mettre à jour',

		paginator_showing: 'Affichage',
		paginator_items: 'éléments',
		paginator_of: 'sur',

		you_are_about_to_delete: 'Vous êtes sur le point de supprimer {{typeTitle}} {{itemName}} !',
		once_deleted: 'Une fois supprimé, cet élément ne peut pas être récupéré.',
		are_you_sure: 'Êtes-vous sûr de vouloir supprimer ?',
		cancel: 'Annuler',
		i_want_to_delete: 'Je veux supprimer',

		the_company_will_no_longer: 'L\'entreprise ne sera plus listée. Toutes les données de l\'entreprise seront supprimées.',
		create_a_company: 'Créer votre entreprise',
		create_company_information: 'Informations de l\'entreprise',
		create_company_information_description: 'Veuillez fournir les informations commerciales concernant votre entreprise. À des fins de facturation, faites attention à tous les champs marqués d\'un *.',

		create_company_form_label_name: 'Nom',
		create_company_form_label_legal_name: 'Raison sociale',
		create_company_form_label_vat: 'TVA',
		create_company_form_label_email: 'E-mail',
		create_company_form_label_city: 'Ville',
		create_company_form_label_country: 'Pays',
		create_company_form_label_address: 'Adresse',
		create_company_form_label_zipcode: 'Code postal',
		create_company_form_label_phone: 'Téléphone de contact',
		create_company_form_label_website: 'Site web',

		create_company_form_label_name_placeholder: 'Ex. : ABC Corporation',
		create_company_form_label_legal_name_placeholder: 'Ex. : ABC Holdings Ltd.',
		create_company_form_label_vat_placeholder: 'Ex. : FR12345678901',
		create_company_form_label_email_placeholder: 'Ex. : contact@entreprise.com',
		create_company_form_label_city_placeholder: 'Ex. : Paris',
		create_company_form_label_country_placeholder: 'Ex. : France',
		create_company_form_label_address_placeholder: 'Ex. : 123 Parc d\'affaires, Rue principale',
		create_company_form_label_zipcode_placeholder: 'Ex. : 75001',
		create_company_form_label_phone_placeholder: 'Ex. : +33 1 23 45 67 89',
		create_company_form_label_website_placeholder: 'Ex. : https://www.entreprise.com',
		create_company_form_label_name_error: 'Le nom est obligatoire',
		create_company_form_label_legal_name_error: 'La raison sociale est obligatoire',
		create_company_form_label_vat_error: 'Le numéro de TVA est obligatoire',
		create_company_form_label_email_error: 'L\'e-mail est obligatoire',

		create_webhook_address_cancelation: 'Adresse Webhook d\'annulation',
		create_webhook_address_confirmation: 'Adresse Webhook de confirmation',
		create_webhook_address_sale: 'Adresse Webhook de vente',
		create_webhook_address_cancelation_placeholder: 'Entrez l\'adresse webhook d\'annulation',
		create_webhook_address_confirmation_placeholder: 'Entrez l\'adresse webhook de confirmation',
		create_webhook_address_sale_placeholder: 'Entrez l\'adresse webhook de vente',

		create_company_form_click_here_select_logotype: 'Cliquez ici pour sélectionner le logo',
		create_company_form_click_here_select_cover_image: 'Cliquez ici pour sélectionner l\'image de couverture',

		edit_company_page_title: 'Informations de l\'entreprise',
		edit_company_page_description: 'Modifiez les informations de votre entreprise',

		create_company_save_company: 'Enregistrer',

		table_head_label_name: 'Nom',
		table_head_label_priority: 'Priorité',
		table_head_label_status: 'Statut',
		table_head_label_actions: 'Actions',
		table_head_label_start: 'Date de début',
		table_head_label_end: 'Date de fin',
		table_head_label_type: 'Type',
		table_head_label_gateways: 'Passerelles',
		table_head_label_payment_methods: 'Méthodes de paiement',
		table_head_label_store_name: 'Magasin',
		table_head_label_amount: 'Montant',
		table_head_label_start_date: 'Date de début',
		table_head_label_final_date: 'Date de fin',
		table_head_label_date: 'Date',
		table_head_label_gateway: 'Passerelle',
		table_head_label_payment_method: 'Méthode de paiement',
		table_head_label_validity: 'Validité',
		table_head_label_stores: 'Magasins',
		table_head_label_company_name: 'Entreprise',
		table_head_label_legal_name: 'Raison sociale',
		table_head_label_role: 'Rôle',
		table_head_label_active: 'Actif',

		active_company_header_navbar: 'Entreprise active',
		active_company_informations_header_navbar: 'Informations de l\'entreprise',
		active_company_users_header_navbar: 'Gestion des utilisateurs',
		active_company_roles_header_navbar: 'Rôles des utilisateurs',

		company_user_management_page_title: 'Gestion des utilisateurs',
		company_user_management_page_description: 'Gérer les utilisateurs associés à votre entreprise',
		company_user_management_send_invite: 'Envoyer une invitation',

		toast_user_role_updated: 'Rôle de l\'utilisateur mis à jour avec succès',
		toast_error_updating_user_role: 'Une erreur s\'est produite lors de la mise à jour du rôle',

		toast_error_no_grant: 'Vous n\'avez pas la permission d\'effectuer cette action',

		company_roles_page_title: 'Rôles',
		company_roles_page_description: 'Informations sur les rôles d\'utilisateur liés à l\'entreprise',
		company_role_create_role: 'Ajouter un rôle',

		invite_user_drawer_title: 'Inviter un utilisateur',
		invite_user_drawer_description: 'Invitez un nouvel utilisateur à rejoindre l\'entreprise en remplissant le formulaire ci-dessous.',
		invite_user_drawer_email: 'E-mail',
		invite_user_drawer_email_placeholder: 'E-mail de l\'utilisateur',
		invite_user_email_error: 'L\'e-mail est obligatoire',
		invite_user_drawer_role: 'Rôle de l\'utilisateur',
		select_role_placeholder: 'Sélectionner un rôle',
		send_invitation: 'Envoyer l\'invitation',

		invitation_sent_successfully: 'Invitation envoyée avec succès',
		error_sending_invitation: 'Une erreur s\'est produite lors de l\'envoi de l\'invitation',

		the_user: 'l\'utilisateur',
		the_user_will_be_removed: 'L\'utilisateur sera retiré de l\'entreprise et n\'aura plus accès à ses ressources.',
		toast_user_role_deleted: 'L\'utilisateur a été retiré',
		toast_error_deleting_user_role: 'Une erreur s\'est produite lors du retrait de l\'utilisateur',
		toast_user_role_not_been_deleted: 'L\'utilisateur n\'a pas été retiré.',

		create_role_drawer_title: 'Créer un rôle',
		create_role_drawer_description: 'Remplissez le formulaire pour créer le rôle. Tous les champs doivent être complétés. Les champs marqués d\'un * sont obligatoires.',
		create_role_drawer_label_name: 'Nom',
		create_role_drawer_label_actions: 'Actions',
		create_role_drawer_label_invites: 'Invitations',
		create_role_drawer_label_resource: 'Ressources',
		create_role_drawer_label_active: 'Actif',
		create_role_drawer_label_permissions: 'Permissions',
		create_role_drawer_label_company: 'Entreprises',
		create_role_drawer_label_role: 'Rôles',
		create_role_drawer_label_users: 'Utilisateurs',
		create_role_drawer_label_create: 'Créer',
		create_role_drawer_label_read: 'Lire',
		create_role_drawer_label_update: 'Mettre à jour',
		create_role_drawer_label_delete: 'Supprimer',
		create_role_drawer_label_name_placeholder: 'Nom du rôle',
		create_role_drawer_label_api_keys: 'Clés d\'accès API',

		toast_role_created: 'Le rôle a été créé.',
		toast_error_creating_role: 'Une erreur s\'est produite lors de la création du rôle.',
		toast_role_updated: 'Le rôle a été mis à jour.',
		toast_error_updating_role: 'Une erreur s\'est produite lors de la mise à jour du rôle.',
		toast_role_status_updated: 'Le statut du rôle a été mis à jour.',
		toast_error_updating_role_status: 'Une erreur s\'est produite lors de la mise à jour du statut du rôle.',
		toast_role_not_updated: 'Le rôle n\'a pas été mis à jour.',
		toast_role_not_created: 'Le rôle n\'a pas été créé.',
		toast_role_deleted: 'Le rôle a été supprimé.',
		toast_error_deleting_role: 'Une erreur s\'est produite lors de la suppression du rôle.',
		toast_role_not_been_deleted: 'Le rôle n\'a pas été supprimé.',
		the_role: 'le rôle',
		the_role_will_be_removed: 'Le rôle sera supprimé de tous les endroits où il est utilisé.',

		pwa_page_title: 'PWA',
		pwa_page_description: 'Modifier vos PWA',
		pwa_create_pwa: 'Créer une PWA',
		toast_status_pwa_changed: 'Statut de la PWA modifié',
		toast_error_changing_pwa_status: 'Erreur lors de la modification du statut de la PWA',

		edit_pwa_drawer_title: 'Modifier la PWA',
		create_pwa_drawer_title: 'Créer une PWA',
		create_edit_pwa_drawer_description: 'Créer ou modifier votre PWA',
		create_pwa_form_label_name: 'Nom de la PWA',
		create_pwa_form_label_image: 'Image',
		create_pwa_form_label_luope_id: 'Identifiant Luope',
		create_pwa_form_label_shared_key: 'Clé partagée',
		create_pwa_form_label_subdomain: 'Sous-domaine',
		create_pwa_form_label_theme: 'Thème',

		create_pwa_form_placeholder_name: 'Insérer le nom',
		create_pwa_form_placeholder_luope_id: 'Insérer l\'identifiant Luope',
		create_pwa_form_placeholder_shared_key: 'Insérer la clé partagée',
		create_pwa_form_placeholder_subdomain: 'Insérer le sous-domaine',
		create_pwa_form_placeholder_theme: 'Insérer le thème',
		update_pwa: 'Mettre à jour la PWA',
		create_pwa: 'Créer une PWA',
		toast_pwa_created: 'PWA créée avec succès',
		toast_error_creating_pwa: 'Une erreur s\'est produite lors de la création de la PWA',
		toast_pwa_updated: 'PWA mise à jour avec succès',
		toast_error_updating_pwa: 'Une erreur s\'est produite lors de la mise à jour de la PWA',

		toast_error_loading_pwa: 'Erreur lors du chargement des PWA',
		toast_pwa_not_been_deleted: 'La PWA n\'a pas été supprimée',
		toast_error_deleting_pwa: 'Une erreur s\'est produite lors de la suppression de la PWA',
		toast_pwa_deleted: 'PWA supprimée avec succès',
		invalid_json_format: 'Format invalide pour ce champ',

		error_required_field: 'Ce champ est obligatoire',
		
		menu_files: 'Fichiers',
		sidebar_more: 'Plus',
		company_files_page_title: 'Fichiers',
		company_files_page_description: 'Télécharger et gérer vos fichiers',
		company_files_create_file: 'Fichier',

		create_loading_file_drawer_title: 'Téléchargement de fichier',
		create_loading_file_drawer_description: 'Suivre la progression de vos fichiers',
		create_loading_file_drawer_upload: 'Choisir les fichiers',

		select_files_drawer_title: 'Sélection de fichiers',
		select_files_drawer_description: 'Sélectionner les fichiers à intégrer dans l\'entreprise, le magasin et/ou les produits du magasin',

		toast_files_created: 'Les fichiers ont été téléchargés.',
		toast_files_created_error: 'Une erreur s\'est produite lors du téléchargement des fichiers',
		toast_files_tried_upload_not_accepted: 'Les fichiers que vous avez essayé de télécharger ne sont pas acceptés. Seuls les fichiers jpeg, jpg, svg ou png seront acceptés.',
		toast_file_deleted: 'Le fichier a été supprimé.',
		toast_error_deleting_file: 'Une erreur s\'est produite lors de la suppression d\'un fichier.',
		toast_file_not_been_eliminated: 'Le fichier n\'a pas été supprimé.',

		the_file: 'le fichier',
		the_file_will_be_removed: 'Le fichier sera supprimé de tous les endroits où il est utilisé.',

		toast_error_company_files: 'Une erreur s\'est produite lors du chargement des fichiers',
		toast_error_server: 'Une erreur s\'est produite lors de la connexion au serveur. Veuillez réessayer.',

		toast_company_created: 'L\'entreprise a été créée avec succès.',
		toast_error_creating_company: 'Une erreur s\'est produite lors de la création de l\'entreprise.',
		toast_info_file_selected: 'Fichier sélectionné.',
		toast_company_eliminated: 'L\'entreprise a été supprimée avec succès.',
		toast_error_deleting_company: 'Une erreur s\'est produite lors de la suppression de l\'entreprise.',
		toast_company_not_been_eliminated: 'L\'entreprise n\'a pas été supprimée avec succès.',
		toast_company_updated: 'L\'entreprise a été mise à jour avec succès.',
		toast_error_updating_company: 'Une erreur s\'est produite lors de la mise à jour de l\'entreprise.',
		the_pwa_will_be_removed: 'La PWA sera supprimée.',
		the_pwa: 'La PWA',
		location_not_authrozied_warning: 'Les autorisations de localisation n\'ont pas été accordées.',

		create_pwa_form_label_final_message: 'Message d\'utilisation de la machine',
		create_pwa_form_placeholder_final_message: 'Insérez le message d\'utilisation de la machine',

		create_pwa_form_label_final_message_switch: 'Afficher le message d\'utilisation de la machine',
		create_pwa_form_label_logo: 'Logo de la PWA',
		create_pwa_form_label_cover: 'Couverture de la PWA',
		
		create_pwa_form_label_customization: 'Personnalisation',
		create_pwa_form_label_color: 'Couleur',

		theme_primary_color: 'Couleur principale',
		theme_secondary_color: 'Couleur secondaire',
		theme_background_color: 'Couleur de fond',
		theme_accent_color: 'Couleur d\'accent',
		theme_action_color: 'Couleur d\'action',
		theme_success_color: 'Couleur de succès',
		theme_warning_color: 'Couleur d\'avertissement',
		theme_danger_color: 'Couleur de danger',
		theme_logo_cover_color: 'Couleur de la couverture du logo',
		theme_primary_font_color: 'Couleur de police principale',
		theme_secondary_font_color: 'Couleur de police secondaire',
		theme_btn_action_color: 'Couleur du bouton d\'action',
		theme_btn_font_action_color: 'Couleur du texte du bouton d\'action',
		theme_highlight_font_color: 'Couleur du texte de surbrillance',

		theme_description_primary_color: 'La couleur principale utilisée dans toute l\'application',
		theme_description_secondary_color: 'La couleur secondaire utilisée dans toute l\'application',
		theme_description_background_color: 'La couleur de fond de l\'application',
		theme_description_accent_color: 'La couleur d\'accent pour les éléments en surbrillance',
		theme_description_action_color: 'La couleur des éléments d\'action utilisateur',
		theme_description_success_color: 'La couleur des états de succès',
		theme_description_warning_color: 'La couleur des états d\'avertissement',
		theme_description_danger_color: 'La couleur des états d\'erreur',
		theme_description_logo_cover_color: 'La couleur de la couverture du logo',
		theme_description_primary_font_color: 'La couleur principale du texte',
		theme_description_secondary_font_color: 'La couleur secondaire du texte',
		theme_description_btn_action_color: 'La couleur des boutons d\'action utilisateur',
		theme_description_btn_font_action_color: 'La couleur du texte des boutons d\'action utilisateur',
		theme_description_highlight_font_color: 'La couleur du texte de surbrillance',

		reset_theme: 'Réinitialiser le thème',
	}
};
